import { FaLink } from "react-icons/fa";
import { CustomLink, DescriptionBody, StatCard } from "../../common";
import { urlsPages } from "../../common/urls/urls-pages";
import { UrlUtils } from "../../config/utils/url-utils";
import { SessionListItem } from "./application/domain/session-list-item";

function formatCreatedAt(iso: string): string {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return new Intl.DateTimeFormat("pt-BR", {
        dateStyle: "short",
        timeStyle: "short",
    }).format(d);
}

type SessionListItemProps = {
    session: SessionListItem;
};

export const SessionListItemCard: React.FC<SessionListItemProps> = ({ session }) => {
    const connectionUrl = UrlUtils.goToPage(urlsPages.connection, session.workoutId);
    const description = session.workout;        
    return (
        <CustomLink to={connectionUrl} width="100%">
            <StatCard
                title={session.name}
                description={description}
                stats={[
                   
                ]}
                leadingIcon={<FaLink />}
                footerContent={
                    <>
                    <DescriptionBody>{formatCreatedAt(session.status)}</DescriptionBody>
                    <DescriptionBody>{formatCreatedAt(session.createdAt)}</DescriptionBody>
                    </>
                }
            />
        </CustomLink>
    );
};
